import { useEffect, useState } from 'react'
import Renderer, { Renderable } from '../classes/renderer'

export function useRenderer(canvas: HTMLCanvasElement | null, nodes?: Renderable[], transparency?: boolean) {
    const [state, setState] = useState<Renderer | null>(null)

    useEffect(() => {
        if (!canvas) return

        const gl = canvas.getContext('webgl', {
            alpha: transparency || false,
            antialias: false,
            depth: false,
            desynchronized: true,
            powerPreference: 'high-performance',
            premultipliedAlpha: true,
            preserveDrawingBuffer: false,
        })

        if (!gl) {
            throw `unable to get webgl context`
        }

        setState(new Renderer(gl))
    }, [canvas, transparency])

    useEffect(() => {
        if (!state || !nodes) return

        state.setNodes(nodes)
    }, [nodes, state])

    return state
}
